<template>
  <div>
    <SupplierOrderFilters
      :number.sync="payload.number"
      :orderStatusId.sync="payload.orderStatusId"
      :surgeryId.sync="payload.surgeryId"
      @apply="getSupplierOrders(payload)"
    />
    <loading v-show="loading" />
    <v-card v-show="!loading" elevation="0" outlined>
      <v-app-bar flat dense elevation="0" color="transparent">
        <v-toolbar-title> <h4>Supplier Orders</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <template>
          <v-data-table
            :headers="headers"
            :items="supplierOrders"
            show-select
            v-model="selected"
            :server-items-length="totalItems"
            :options.sync="pagination"
            :items-per-page="pagination.itemsPerPage"
            @pagination="updatePagination"
            :disable-pagination="false"
            :footer-props="{
              disablePagination: false,
              disableItemsPerPage: false
            }"
            class="elevation-0 black--text"
          >
            <template slot="item" slot-scope="props">
              <tr @click="$router.push({'name': 'supplierorder-detail', params: {supplierId: props.item.supplierId ,id: props.item.id }})">
                <td>
                  <v-simple-checkbox
                    color="primary"
                    v-ripple
                    @input="select($event)"
                  ></v-simple-checkbox>
                </td>
                <td class="text-left">
                  <!-- <v-avatar size="30px">
                           <img :src="props.item.logo" :alt="props.item.logo" />
                        </v-avatar> -->
                  {{ props.item.name }}
                </td>
                <td class="text-left">
                  {{ props.item.createdAt | relativeCreationDate }}
                </td>
                <td class="text-left">
                  {{ props.item.number }}
                </td>
                <td class="text-left">{{ props.item.quantity }}</td>
                <td class="text-left">
                  {{ props.item.price.currency }} {{ props.item.price.total }}
                </td>
                <td class="text-left">
                  {{ props.item.user.firstName }} {{ props.item.user.lastName }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </template>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import moment from "moment";
import VuemomentJS from "vue-momentjs";
import Helpers from "@/mixins/helpers";
import SupplierOrderFilters from "./SupplierOrderFilters";
export default {
  mixins: [Helpers],
  components: {
    SupplierOrderFilters
  },
  filters: {
    relativeCreationDate: function(date) {
      return moment.utc(date).fromNow();
    }
  },
  data() {
    let vm = this;
    return {
      supplierId: null,
      loading: true,
      selected: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: false,
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      headers: [
        {
          text: "Supplier",
          align: "left",
          sortable: false,
          value: "supplier"
        },
        {
          text: "Ordered At",
          align: "left",
          sortable: false,
          value: "createdAt"
        },
        {
          text: "Order Number",
          align: "left",
          sortable: false,
          value: "number"
        },
        {
          text: "Quantity",
          align: "left",
          value: "quantity"
        },
        {
          text: "Total Price",
          align: "left",
          value: "price.total"
        },
        { text: "User", value: "name" }
        // { text: "", value: "action", align: "right" }
      ],
      payload: {
        from: 0,
        to: 10,
        number: " ",
        surgeryId: null,
        orderStatusId: null
      }
    };
  },
  computed: {
    supplierOrders() {
      return this.$store.state.supplierorders.supplierOrders;
    },
    totalItems() {
      return this.$store.state.supplierorders.total;
    }
  },
  created() {
    this.getSupplierOrders(this.payload);
  },
  methods: {
    async getSupplierOrders(payload) {
      this.loading = true;
      await this.$store.dispatch(
        "supplierorders/LOAD_SUPPLIER_ORDERS",
        payload
      );
      this.loading = false;
    },
    updatePagination(pagination) {
      let payload = this.payload;
      payload.from =
        pagination.page * pagination.itemsPerPage - pagination.itemsPerPage;
      payload.to =
        pagination.itemsPerPage === -1
          ? this.totalItems
          : pagination.itemsPerPage;
      this.getSupplierOrders(payload);
    },
    async deleteAndRefresh(id) {
      let res = await this.destroy(id);
      if (res) {
        let payload = {
          from:
            this.pagination.page * this.pagination.itemsPerPage -
            this.pagination.itemsPerPage,
          to:
            this.pagination.itemsPerPage === -1
              ? this.totalItems
              : this.pagination.itemsPerPage
        };
        this.getSupplierOrders(payload);
      }
    }
  }
};
</script>
